import { connect } from 'react-redux';
import Page from '../../app/components/Page';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import {routerActions} from 'react-router-redux';
import {FormattedMessage, injectIntl, intlShape} from "react-intl";
import OrderTrackingForm from "../forms/OrderTrackingForm";
import ImmutablePropTypes from "react-immutable-proptypes";
import {GET_TRACKING, GET_TRACKING_SUCCESS, GET_TRACKING_FAILURE} from "../tracking";
import {createSubmitAction} from "../../app/forms";
import Helmet from 'react-helmet';

@injectIntl
export class Tracking extends Component {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
        children: PropTypes.node,
        tracking: ImmutablePropTypes.map.isRequired,
        intl: intlShape,
    };

    handleSubmitSuccess() {
        const { dispatch, tracking } = this.props;

        console.log(tracking);

        dispatch(routerActions.push("/orders/" + tracking.get('code')));
    }


    render() {

        const { formatMessage } = this.props.intl;

        return (
            <Page>
                <Helmet title={formatMessage({ id: 'frontend.pagetitle.track' })} />
                <Page.Body>
                    <Page.Section depth={0}>
                        <h1>
                            <FormattedMessage id='frontend.orders.tracking.label'/>
                        </h1>

                        <OrderTrackingForm onSubmitSuccess={this.handleSubmitSuccess.bind(this)}
                            onSubmit={createSubmitAction(
                                GET_TRACKING,
                                GET_TRACKING_SUCCESS,
                                GET_TRACKING_FAILURE,
                            )} />

                    </Page.Section>
                </Page.Body>
            </Page>
        );
    }
}

export default withRouter(connect(state => ({
    tracking: state.tracking,
}))(Tracking));

